<template>
    <div class="tabs">
        <span
            class="tab"
            :class="state.params.timeStatus === null && 'active'"
            @click="changeSt(null)"
        >
            全部任务
        </span>
        <span
            class="tab"
            :class="state.params.timeStatus === 1 && 'active'"
            @click="changeSt(1)"
        >
            本月
        </span>
        <span
            class="tab"
            :class="state.params.timeStatus === 2 && 'active'"
            @click="changeSt(2)"
        >
            本季度 {{ state.params.timeStatus }}
        </span>
        <span
            class="tab"
            :class="state.params.timeStatus === 3 && 'active'"
            @click="changeSt(3)"
        >
            本年
        </span>
    </div>
    <div class="total">
        <div class="to-item status4">
            <img src="@/assets/echarts/postpone.png">
            <div class="to-nums">
                <p>{{ state.info?.postpone || 0 }}</p>
                <p>已延期</p>
            </div>
        </div>
        <div class="to-item status3">
            <img src="@/assets/echarts/underway.png">
            <div class="to-nums">
                <p>{{ state.info?.underway || 0 }}</p>
                <p>进行中</p>
            </div>
        </div>
        <div class="to-item status2">
            <img src="@/assets/echarts/done.png">
            <div class="to-nums">
                <p>{{ state.info?.done || 0 }}</p>
                <p>已完成</p>
            </div>
        </div>
        <div class="to-item status1">
            <img src="@/assets/echarts/all.png">
            <div class="to-nums">
                <p>{{ state.info?.all || 0 }}</p>
                <p>全部</p>
            </div>
        </div>
        <!-- <div class="to-item status5">
            <img src="@/assets/home/user5.svg">
            <div class="to-nums">
                <p>30</p>
                <p>常态化运行</p>
            </div>
        </div> -->
    </div>
    <el-table
        ref="tableRef"
        v-loading="loading"
        :data="state.tableData"
        border
        stripe
        size="small"
        style="height: 275px; "
    >
        <el-table-column
            label="序号"
            prop="index"
            align="center"
            width="80"
        />
        <el-table-column
            label="任务状态"
            prop="a1"
            width="80"
            align="center"
        >
            <template #default="scope">
                <StatusTag :status="scope.row.status" />
            </template>
        </el-table-column>
        <el-table-column
            label="任务名称/任务目标"
            prop="keyTask"
            align="center"
            :min-width="220"
        >
            <template #default="scope">

                <el-tooltip
                    effect="dark"
                    raw-content
                    :content="`<div style='max-width: 300px'>${scope.row.keyTask}</div>`"
                    placement="top"
                >
                    <p
                        class="task-name target"
                        @click="jumpRouter(scope.row)"
                    >
                        {{ scope.row.keyTask }}
                    </p>
                </el-tooltip>
                <p class="task-cn">
                    <span class="tableCellReviewLeft normal">{{ scope.row.objective }}</span>
                </p>
            </template>
        </el-table-column>

        <!-- <el-table-column
            label="所属任务"
            prop="source"
            align="center"
            show-overflow-tooltip
        /> -->
        <el-table-column
            label="执行人"
            prop="executor"
            align="center"
            show-overflow-tooltip
        />
        <el-table-column
            label="完成时间"
            prop="dueDate"
            align="center"
        >
            <template #default="scope">
                {{ scope.row.dueDate?.substring(0, 10) }}
            </template>
        </el-table-column>
    </el-table>
    <div class="pagination">
        <span />
        <el-pagination
            v-model:currentPage="state.params.pageNum"
            v-model:page-size="state.params.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="state.total"
            small="small"
            @size-change="sizeChange"
            @current-change="queryData"
        />
    </div>

</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import axios from '@/plugins/axios';
import { useRouter } from 'vue-router';

const loading = ref(false);
const router = useRouter();

const props = defineProps({
    id: {
        type: String,
        default: () => ''
    }
});

const state = reactive({
    params: {
        pageNum: 1,
        pageSize: 10,
        timeStatus: null
    },
    info: {},
    total: 0,
    tableData: [],
    treeList: []
});

onMounted(() => {
    queryData();
});

const queryData = async() => {
    loading.value = true;
    const resCount = await axios({
        url: 'pending/task/principal/count',
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            ...state.params,
            principalId: props.id
        }
    });
    const res = await axios({
        url: '/pending/task/query/principal',
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            ...state.params,
            principalId: props.id
        }
    });
    const { pageSize, pageNum } = state.params;
    const list = res?.data?.records?.map((it, index) => {
        it.index = pageSize * (pageNum - 1) + index + 1;
        return it;
    });
    state.info = resCount.data;
    state.total = Number(res?.data?.total || 0);
    state.tableData = list;
    loading.value = false;
};

const changeSt = (status) => {
    state.params.timeStatus = status;
    queryData();
};

const sizeChange = () => {
    state.params.pageNum = 1;
    queryData();
};

const jumpRouter = (row) => {
    router.push(`/task/waitDeal/${row.id}`);
};

</script>

<style lang="scss" scoped>
.tabs {
    display: flex;
    align-items: center;
    .tab {
        margin-right: 32px;
        display: inline-block;
        font-size: 14px;
        color: #737373;
        position: relative;
        cursor: pointer;
        &.active {
            color: #262626;
            font-weight: bold;
            &::after {
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                content: '';
                width: 26px;
                border-bottom: 3px solid #3EA7F5;;
            }
        }
    }
}
.total {
    display: flex;
    justify-content: space-between;
    margin-top: 28px;
    margin-bottom: 20px;
    .to-item {
        width: 177px;
        height: 62px;
        display: inline-flex;
        align-items: center;
        border-radius: 4px;
        &.status1 {
            background: #DDF1FF;
        }
        &.status2 {
            background: #F1F9EB;
        }
        &.status3 {
            background: #FEECCC;
        }
        &.status4 {
            background: #FFEDEA;
        }
        &.status5 {
            background: #FEECCC;
        }
        img {
            width: 36px;
            height: 36px;
            display: inline-block;
            margin-left: 16px;
        }
        .to-nums {
            font-size: 14px;
            color: #262626;
            margin-left: 15px;
            p {
                line-height: 20px;
            }
        }
    }
}
.task-name {
    font-size: 14px;
    text-align: left;
    color: #179AEE;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    display: block;
    overflow: hidden;
}

.task-cn {
    font-size: 12px;
    color: #737373;
    text-align: left;
}
.pagination {
    margin-top: 14px;
    display: flex;
    justify-content: flex-end;
}
</style>
